import {
  comments_returned,
  comment_received,
  user_signed_out,
  set_show_comments,
  comments_requested,
  comment_updated,
  comment_deleted,
  set_show_delete_comment
} from '../actions/types';

const INITIAL_STATE = {
  comments: {},
  commentsLoading: true,
  showComments: null,
  showDeleteComment: null
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case comments_requested:
      return { ...state, commentsLoading: true };

    case comments_returned: {
      const comments = action.payload;

      if (comments.length > 0) {
        if (Array.isArray(state.comments[comments[0].shoutout_id])) {
          state.comments[comments[0].shoutout_id].concat(comments);

          let found = [];

          state.comments[comments[0].shoutout_id] = state.comments[comments[0].shoutout_id].filter(comment => {
            if (found.indexOf(comment._id) > -1) {
              return false;
            } else {
              found.push(comment._id);
              return true;
            }
          });
        } else {
          state.comments[comments[0].shoutout_id] = comments;
        }
      }

      for (let i in state.comments) {
        state.comments[i].sort((a, b) => ((new Date(a.timestamp)).getTime() - (new Date(b.timestamp)).getTime()));
      }

      return { ...state, comments: { ...state.comments }, commentsLoading: false };
    }
    case comment_received: {
      const comment = action.payload;

      if (Array.isArray(state.comments[comment.shoutout_id])) {
        state.comments[comment.shoutout_id] = [...state.comments[comment.shoutout_id], comment];
      } else {
        state.comments[comment.shoutout_id] = [ comment ];
      }

      return { ...state, comments: { ...state.comments } };
    }
    case user_signed_out:
      return { ...INITIAL_STATE };

    case set_show_comments:
      return { ...state, showComments: action.payload };

    case set_show_delete_comment:
      return { ...state, showDeleteComment: action.payload };

    case comment_updated: {
      let allComments = { ...state.comments };
      let soComments = [ ...state.comments[action.payload.shoutout_id] ];
      let ids = soComments.map((comment) => comment._id);
      soComments[ids.indexOf(action.payload.id)].text = action.payload.text;
      allComments[action.payload.shoutout_id] = soComments;
      return { ...state, comments: { ...allComments } };
    }
    case comment_deleted: {
      let allComments = { ...state.comments };
      let soComments = [ ...state.comments[action.payload.shoutout_id] ];
      let ids = soComments.map((comment) => comment._id);
      soComments.splice(ids.indexOf(action.payload.id), 1);
      allComments[action.payload.shoutout_id] = soComments;
      return { ...state, comments: { ...allComments }, showDeleteComment: null };
    }
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/CommentsReducer.js